
import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Button } from "@/components/ui/button";
import { FileText, Printer } from "lucide-react";
import { useNavigate } from 'react-router-dom';
import AdminHistoryTab from '@/components/admin/history/AdminHistoryTab';
import StudentHistoryTab from '@/components/admin/history/StudentHistoryTab';
import TeacherHistoryTab from '@/components/admin/history/TeacherHistoryTab';
import { toast } from 'sonner';

const HistoryManagementPage = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('students');
  
  return (
    <div className="w-full p-6">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold">History Management</h1>
        <Button variant="outline" onClick={() => navigate('/admins')}>
          Back to Admin Dashboard
        </Button>
      </div>

      <Tabs defaultValue="students" className="space-y-4" onValueChange={setActiveTab}>
        <TabsList className="grid w-full grid-cols-3">
          <TabsTrigger value="students">Student History</TabsTrigger>
          <TabsTrigger value="teachers">Teacher History</TabsTrigger>
          <TabsTrigger value="admin">Administrative History</TabsTrigger>
        </TabsList>

        <TabsContent value="students">
          <StudentHistoryTab />
        </TabsContent>

        <TabsContent value="teachers">
          <TeacherHistoryTab />
        </TabsContent>

        <TabsContent value="admin">
          <AdminHistoryTab />
        </TabsContent>
      </Tabs>

      <div className="mt-6 text-sm text-muted-foreground">
        <p>The history management system tracks all actions performed in the system. Select a tab to view specific history records.</p>
        <ul className="list-disc pl-5 mt-2">
          <li>Student History shows enrollment events, program transfers, and status changes</li>
          <li>Teacher History displays teaching assignments, payments, and account activities</li>
          <li>Administrative History records system settings changes and administrative actions</li>
        </ul>
      </div>
    </div>
  );
};

export default HistoryManagementPage;
